import { render } from "./PrjProjectFinancial.vue?vue&type=template&id=4a08d5f7&scoped=true"
import script from "./PrjProjectFinancial.vue?vue&type=script&lang=js"
export * from "./PrjProjectFinancial.vue?vue&type=script&lang=js"

import "./PrjProjectFinancial.vue?vue&type=style&index=0&id=4a08d5f7&lang=less&scoped=true"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a08d5f7"]])

export default __exports__